import { all, fork, put, takeEvery } from 'redux-saga/effects';
// eslint-disable-next-line import/no-cycle
import apolloClient from 'services/graphql/config';

import { GET_SINGLE_USER } from '../../services/graphql/queries/user.query';
// import UserService from 'services/api/user.service';
import { StandardAction } from '../types';
import { FetchUserPayload } from './types';
import UserAction from './user.actions';

const { FETCH_USER, UPDATE_USER } = UserAction.TYPES;

function* fetchUser(action: StandardAction<FetchUserPayload>) {
  const { payload } = action;

  if (payload) {
    const { email } = payload;
    try {
      const { data } = yield apolloClient.query({
        query: GET_SINGLE_USER,
        variables: {
          email,
        },
      });

      yield put(UserAction.fetchUserSuccess(data.findOneUserEntity));
    } catch (error) {
      yield put(UserAction.fetchUserError());
    }
  }
}

// placeholder for update user saga
function* updateUser(action: StandardAction<any>) {
  const { payload } = action;
  if (payload) {
    try {
      yield put(UserAction.updateUserSuccess('test'));
    } catch (error) {
      // notification.error({
      //   message: error,
      // });
      yield put(UserAction.updateUserError());
    }
  }
}

function* watchFetchUser() {
  yield takeEvery(FETCH_USER.START, fetchUser);
}

function* watchUpdateUser() {
  yield takeEvery(UPDATE_USER.START, updateUser);
}

export default function* rootSaga(): Generator {
  yield all([fork(watchFetchUser), fork(watchUpdateUser)]);
}
